import { PendingTransitionFragment } from '@spotify/confidence-graphql';

export const hasFailingSteps = (
  pendingTransition?: PendingTransitionFragment | null,
) => {
  return pendingTransition && pendingTransition.failedSteps.length > 0;
};
